// extracted by mini-css-extract-plugin
export var pageHeader = "index-module--pageHeader--m9NCm";
export var pageHeaderAlt = "index-module--pageHeaderAlt--2C6e2";
export var headerShareBlock = "index-module--headerShareBlock--3S2no index-module--shareBlock--1A1LU";